<template>
    <Content>
        <h1 class="p-xl">user</h1>
    </Content>
</template>

<script>

export default {
    components: {
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/user/list.vue